export const initialState = {
  user:null,
  loading: false,
  products: [],
  favoriteProducts: [],
  category: 'All',
  cart: [],
  amountTotal: 0,
  total: 0,
  error: null,
};
